import { observer } from "owa-mobx-react";
import loc from "owa-localize";
import { isGlobalFeatureEnabled } from "owa-feature-flags/lib/utils/isFeatureEnabled";
import isWin32StylingEnabled from "owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled";
import React from "react";
import { statusBarPlaceholder } from "./StatusBar.locstring.json";
import { statusBar } from "./StatusBar.scss";

const StatusBar: React.FunctionComponent = observer(function StatusBar() {
    if (!isWin32StylingEnabled() || !isGlobalFeatureEnabled("fwk-status-bar")) {
        return null;
    }
    
    // TODO: Add role="status" when this displays real status updates instead of placeholder text.
    return <div className={statusBar}>{loc(statusBarPlaceholder)}</div>;
}, "StatusBar");

export default StatusBar;
